import { Typography, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import htmlReactParser from 'html-react-parser';
import TabPanel from './TabPanel';
import { ReactComponent as Done } from '../../assets/FTE6.svg';

export default function Tab6(props: { value: number }) {
  const { value } = props;
  const { t } = useTranslation();

  return (
    <TabPanel value={value} index={5}>
      <Stack display="flex" flexDirection="row">
        <Typography>{htmlReactParser(t('content.tutorial.tab6'))}</Typography>
        <Done />
      </Stack>
    </TabPanel>
  );
}
